module.exports = {"513329100":"如龙镇","513329101":"拉日马镇","513329102":"大盖镇","513329200":"沙堆乡","513329201":"乐安乡","513329203":"绕鲁乡","513329204":"色威乡","513329205":"甲拉西乡","513329207":"博美乡","513329208":"尤拉西乡","513329209":"子拖西乡","513329210":"和平乡","513329211":"洛古乡","513329212":"雄龙西乡","513329213":"麻日乡","513329214":"通宵乡","513329215":"友谊乡","513329216":"皮擦乡","513329217":"银多乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513329.json
// module id = 2420
// module chunks = 0